import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from '@nagel-assests';
import { IconSize, TableCell } from '@nagel-types';

const defaultIconSize: IconSize = '16x16';

@Component({
    selector: 'app-icon-list-cell',
    imports: [IconComponent],
    templateUrl: './icon-list-cell.component.html',
    styleUrl: './icon-list-cell.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconListCellComponent {
    cell = input.required<TableCell>();

    readonly iconSize = computed(() => this.cell().options?.iconSize ?? defaultIconSize);
    readonly icons = computed(() => {
        const { value, options } = this.cell();
        const iconMap = options?.iconMap ?? {};
        const labelsMap = options?.valuesMap ?? {};
        const values = typeof value === 'string'
            ? value.split(',').map(item => item.trim())
            : Array.isArray(value) ? value : [];

        return values
            .filter(item => iconMap[item])
            .map(item => ({ name: iconMap[item], label: labelsMap[item] ?? item }));
    });
}
